import { Box, Typography, Chip, IconButton, Stack, useTheme, alpha } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";

/** One order-book row as a card, keeping the grid's log button. */
export const OrderBookCard = ({ row, onViewLog }) => {
  const theme = useTheme();
  const primary = theme.palette.primary.main;
  const hasLog = Array.isArray(row.orderLog) && row.orderLog.length > 0;
  const accent = row.orderExecuted
    ? theme.palette.success.main
    : row.orderPlaced
      ? theme.palette.warning.main
      : theme.palette.error.main;

  return (
    <Box
      sx={{
        borderRadius: 2,
        p: 1,
        border: `1px solid ${alpha(primary, 0.14)}`,
        borderLeft: `3px solid ${alpha(accent, 0.85)}`,
        bgcolor: theme.palette.background.paper,
        display: "flex",
        alignItems: "center",
        gap: 1,
      }}
    >
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography noWrap title={row.symbol} sx={{ fontWeight: 800, fontSize: "0.82rem" }}>
          {row.symbol}
        </Typography>
        <Stack direction="row" spacing={0.5} sx={{ mt: 0.4 }} flexWrap="wrap" useFlexGap>
          <Chip
            size="small"
            label={row.orderPlaced ? "Placed" : "Not placed"}
            color={row.orderPlaced ? "info" : "default"}
            variant={row.orderPlaced ? "filled" : "outlined"}
            sx={{ height: 19, fontSize: "0.62rem", fontWeight: 700 }}
          />
          <Chip
            size="small"
            label={row.orderExecuted ? "Executed" : row.orderPlaced ? "Pending" : "Not executed"}
            color={row.orderExecuted ? "success" : "default"}
            variant={row.orderExecuted ? "filled" : "outlined"}
            sx={{ height: 19, fontSize: "0.62rem", fontWeight: 700 }}
          />
        </Stack>
      </Box>
      <IconButton
        size="small"
        onClick={(e) => {
          e.stopPropagation();
          if (hasLog) onViewLog(row);
        }}
        disabled={!hasLog}
        aria-label={`View order log for ${row.symbol}`}
        sx={{ color: hasLog ? "primary.main" : "action.disabled", flexShrink: 0 }}
      >
        <VisibilityIcon fontSize="small" />
      </IconButton>
    </Box>
  );
};

export default OrderBookCard;
